// import React from "react";
// import { Modal } from "react-bootstrap";
// import { useGlobalContext } from "./context/globalContext";
// import "../index.css";
// const Modal1 = () => {
//   const { showModal1, handleCloseModal1 } = useGlobalContext();

//   return (
//     <Modal show={showModal1} onHide={handleCloseModal1} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Modal 1</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="offerr">
//           <img src="images/offer-image.jpeg" alt="" />
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Modal1;

import React, { useEffect, useState } from "react";
import { Modal, ModalTitle } from "react-bootstrap";
import "../index.css";

const Modal1 = () => {
  const [showModal1, setShowModal1] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal1(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const closeModal1 = () => {
    setShowModal1(false);
  };

  return (
    <Modal
      className="offer-modal"
      show={showModal1}
      onHide={closeModal1}
      centered
    >
      <Modal.Header className="offer-modal-head">
        <ModalTitle className="text-center offer-modal-title">
          {/* Enquire Now */}
        </ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <div className="offerr" style={{}}>
          <img
            src="images/closeSvg.svg"
            alt=""
            style={{
              height: "1.5rem",
              width: "1.5rem",
              position: "absolute",
              //   top: window.innerWidth > 768 ? "1.2rem" : ".75rem",
              left: ".2rem",
              cursor: "pointer",
            }}
            onClick={closeModal1}
          />
          <img
            src="images/offer-image.jpeg"
            alt=""
            style={{
              maxWidth: "100%",
              height: "100%",
              objectFit: "contain", // or "cover" if you prefer
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Modal1;
